import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../services/api';
import { setPageMeta, SITE_URL, DEFAULT_TITLE, DEFAULT_DESCRIPTION } from '../utils/seo';

function getVisitorId() {
  var id = localStorage.getItem('_vid');
  if (!id) {
    id = Date.now().toString(36) + Math.random().toString(36).substring(2, 10);
    localStorage.setItem('_vid', id);
  }
  return id;
}

function getUtmParams(search) {
  var params = new URLSearchParams(search);
  return {
    utmSource: params.get('utm_source') || '',
    utmMedium: params.get('utm_medium') || '',
    utmCampaign: params.get('utm_campaign') || ''
  };
}

// Routes whose title/description are fixed. Detail pages are not listed here:
// they set their own once the article/product is loaded.
var STATIC_PAGES = [
  [/^\/$/, DEFAULT_TITLE, DEFAULT_DESCRIPTION],
  [/^\/articles\/?$/, 'المقالات | Maman Algérienne', 'مقالات ونصائح للأمهات الجزائريات: الحمل، تربية الأطفال، الصحة، الوصفات وتدبير المنزل.'],
  [/^\/products\/?$/, 'المنتجات | Maman Algérienne', 'منتجات مختارة بعناية للأم والطفل من ماما الجزائرية.'],
  [/^\/links\/?$/, 'التحميلات | Maman Algérienne', 'ملفات وموارد مجانية للأمهات من ماما الجزائرية.'],
  [/^\/cart\/?$/, 'سلة التسوق | Maman Algérienne', ''],
  [/^\/login\/?$/, 'تسجيل الدخول | Maman Algérienne', ''],
  [/^\/register\/?$/, 'إنشاء حساب | Maman Algérienne', ''],
  [/^\/admin/, 'لوحة التحكم | Maman Algérienne', '']
];

// Detail routes fill in their title asynchronously, after the API call.
var ASYNC_TITLE = /^\/(articles|products)\/[^/]+/;

// Google Analytics 4. The gtag snippet in index.html has send_page_view
// disabled, so every page view (first load included) is sent from here with the
// real path and the real title — otherwise GA records every article under the
// static home page title from index.html.
function sendGaPageView(path, search) {
  if (typeof window.gtag !== 'function') return;

  var send = function () {
    window.gtag('event', 'page_view', {
      page_title: document.title,
      page_location: window.location.href,
      page_path: path + search
    });
  };

  if (!ASYNC_TITLE.test(path)) {
    send();
    return;
  }

  // Wait (briefly) for the page to publish its own title before reporting.
  var startTitle = document.title;
  var tries = 0;
  var iv = setInterval(function () {
    tries++;
    if (document.title !== startTitle || tries >= 25) {
      clearInterval(iv);
      send();
    }
  }, 100);
}

const PageTracker = () => {
  var location = useLocation();
  var lastTracked = useRef('');

  useEffect(() => {
    var key = location.pathname + location.search;
    if (key === lastTracked.current) return;
    lastTracked.current = key;

    for (var i = 0; i < STATIC_PAGES.length; i++) {
      if (STATIC_PAGES[i][0].test(location.pathname)) {
        setPageMeta({
          title: STATIC_PAGES[i][1],
          description: STATIC_PAGES[i][2],
          url: SITE_URL + (location.pathname === '/' ? '/' : location.pathname)
        });
        break;
      }
    }

    sendGaPageView(location.pathname, location.search);

    var utm = getUtmParams(location.search);
    trackPageView({
      path: location.pathname,
      referrer: document.referrer || '',
      visitorId: getVisitorId(),
      ...utm
    }).catch(function() {});
  }, [location.pathname, location.search]);

  return null;
};

export default PageTracker;
